import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Table } from 'semantic-ui-react';
import { FloatingLabelInput as Input } from '../../../../Elements';
import Text from './Text';
import styles from '../../Form.scss';
import { RootConsumer } from '../../../../RootComponent';

function generateId() {
  return `${Math.random().toString(36)}00000000000000000`.slice(2, 16 + 2);
}

const TextTableWidget = ({ editing, schema, uiSchema, onChange, formData }) => {
  const updateColumnHeader = (e, key) => {
    const newSchema = _.cloneDeep(schema);
    newSchema.items.properties[key].title = e.target.value;
    onChange({ schema: newSchema, uiSchema, formData });
  };
  const addColumn = () => {
    const newSchema = _.cloneDeep(schema);
    const key = generateId();
    newSchema.items.properties[key] = {
      title: `Column ${uiSchema['ui:headers'].length + 1}`,
      type: 'string'
    };
    const newUiSchema = _.cloneDeep(uiSchema);
    const keys = newUiSchema['ui:headers'];
    keys.push(key);
    newUiSchema.items.properties['ui:order'] = keys;
    onChange({ schema: newSchema, uiSchema: newUiSchema, formData });
  };
  const removeColumn = (key, index) => {
    const newSchema = _.cloneDeep(schema);
    delete newSchema.items.properties[key];
    const newUiSchema = _.cloneDeep(uiSchema);
    newUiSchema['ui:headers'].splice(index, 1);
    newUiSchema.items.properties['ui:order'] = newUiSchema['ui:headers'];
    const newFormData = Array.isArray(formData) ? formData.map(row => {
      const newRow = _.cloneDeep(row);
      delete newRow[key];
      return newRow;
    }) : [];
    onChange({ schema: newSchema, uiSchema: newUiSchema, formData: newFormData });
  };

  const tableHeader = (
    <Table.Header>
      <Table.Row>
        {uiSchema['ui:headers'].map((key, index) =>
          <Table.HeaderCell key={index}>
            {!editing && schema.items.properties[key].title}
            {editing &&
              <div style={{ display: 'flex' }}>
                <div style={{ flex: 1 }}>
                  <Input
                    name='textInput'
                    placeholder={`Column ${index + 1}`}
                    value={schema.items.properties[key].title}
                    onChange={(e) => updateColumnHeader(e, key)}
                  />
                </div>
                <span
                  className={styles.deleteItemRelative}
                  style={{ marginTop: '0.5em' }}
                  onClick={() => removeColumn(key, index)}
                >
                  <Icon name='close' />
                </span>
              </div>}
          </Table.HeaderCell>
        )}
      </Table.Row>
    </Table.Header>
  );

  return (
    <RootConsumer>
      {({ isComputer }) =>
        <div>
          <Table stackable>
            {isComputer && tableHeader}
            {!isComputer && editing && tableHeader}
            {(!editing || isComputer) && <Table.Body>
              <Table.Row>
                {uiSchema['ui:headers'].map((item, index) =>
                  <Table.Cell key={index}>
                    <Text placeholder={schema.items.properties[item].title} />
                  </Table.Cell>
                )}
              </Table.Row>
            </Table.Body>}
          </Table>
          {editing && <a onClick={addColumn}>+ Add Column</a>}
          {!editing && <a>+ Add Row</a>}
        </div>}

    </RootConsumer>
  );
};

TextTableWidget.propTypes = {
  editing: PropTypes.bool,
  uiSchema: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  formData: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default TextTableWidget;



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/Widgets/Table.js